import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { formatDate } from "../api";
import ModalWindow from './modalWindow'

export class Datatable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            checkedValues: [],
            myData: this.props.myData,
            myColumns: this.props.columns,
            onItemDelete: this.props.onItemDelete,
            onItemLink: this.props.onItemLink,
            onItemEdit: this.props.onItemEdit,
            onItemView: this.props.onItemView,
            onItemDashboard: this.props.onItemDashboard,
            onItemDuplicate: this.props.onItemDuplicate,
            open: false,
            selected: null
        }
        this.getTdProps = this.getTdProps.bind(this);

    }

    selectRow = (e, i) => {
        const data = this.state.myData;
        data[i]['checked'] = e.target.checked;
        this.setState({ myData: data })
    }

    handleRemoveRows = () => {
        toast.success("Successfully Removed !")
        const data = this.state.myData.filter(x=>!x.checked);
        this.state.onItemDelete(data);
        this.setState({myData: data, open: false});
    };

    onCancel = () => {
        toast.warn("Cancelled ...")
        this.setState({open: false});
    };

    onCopyId = (id) => {
        // Create new element
        var el = document.createElement('textarea');
        // Set value (string to be copied)
        el.value = id;
        // Set non-editable to avoid focus and move outside of view
        el.setAttribute('readonly', '');
        el.style = {position: 'absolute', left: '-9999px'};
        document.body.appendChild(el);
        // Select text inside element
        el.select();
        // Copy text to clipboard
        document.execCommand('copy');
        // Remove temporary element
        document.body.removeChild(el);
        toast.info("Item Copied");

    };

    Capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    
    renderImage = (cellInfo) => {    
        var src = cellInfo.original[this.props.imageUrlField];
        //var ratio = this.props.thumbRatio ? this.props.thumbRatio : 1;
        if (src) { src = src + "_thumb" }

        const imageHtml = <img src={src}  style={{border:"1px solid #021a40", height:50}} alt="" />
        
        if (this.state.onItemView) {
            return  (<a href={cellInfo.original[this.props.imageUrlField]} target='_blank' rel="noopener noreferrer">{imageHtml}</a>)
        } else {
            return  (<span >{imageHtml}</span>)
        }
    }

    renderEditableCell = (cellInfo) => {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => {
                    
                    const data = this.state.myData;
                    data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
                    this.state.onItemEdit(data);
                    this.setState({ myData: data });
                    
                }}
                dangerouslySetInnerHTML={{
                    __html: this.state.myData[cellInfo.index][cellInfo.column.id]
                }}
            />
        );
    }

    renderStandardCell = (cellInfo) => {
        if (this.props.editable) { return this.renderEditableCell(cellInfo) }
        const value = this.state.myData[cellInfo.index][cellInfo.column.id] ? this.state.myData[cellInfo.index][cellInfo.column.id] : null;
        if (this.isDate(value)) { return formatDate(new Date(value)) }
        else if (this.isArray(value)) { return this.formatArray(value) }
        else return value;
    }

    formatArray(value) {
        return value.join(", ");
    }

    isArray(value) {
        return Array.isArray(value);
    }

    isDate(value) {
        switch (typeof value) {
            case 'number':
                return false;
            case 'string':
                const d = new Date(value);
                try {
                    const s = d.toISOString();
                    if (s === value) return true;
                    return false;
                } catch(ex) {
                    return false;
                }
            case 'object':
                if (value instanceof Date) {
                    return !isNaN(value.getTime());
                }
                break;
            default:
                return false;
        }
    }

    getTdProps(state, rowInfo, column) {
        if (rowInfo && rowInfo.row && column.id !== "delete") {
            return {
                onClick: () => { 
                    if (this.state.onItemEdit) {
                        this.state.onItemEdit(rowInfo.original); 
                    } else if (this.state.onItemLink) {
                        this.state.onItemLink(rowInfo.original);
                    } 
                },
                onMouseOver: (e) => {
                    this.setState({
                        selected: rowInfo.index
                    })
                },
                style: {
                    background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                    //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                }
            }
        } else { return {} }
    }
    
    render() {
        const { pageSize, myClass, multiSelectOption, pagination } = this.props;
        var { myData, myColumns } = this.state
        const columns = [];
        for (var key in myColumns) {
            const value = myColumns[key];
            /*
            let editable = this.renderEditable
            if (value === "image") {
                editable = null;
            }
            if (value === "status") {
                editable = null;
            }
            if (value === "avatar") {
                editable = null;
            }
            if (value === "vendor") {
                editable = null;
            }
            if(value === "order_status"){
                editable = null;
            }
            */
            if (value === this.props.imageUrlField) {
                columns.push(
                {
                    Header: <b>{this.Capitalize('image')}</b>,
                    accessor: value,    
                    Cell: this.renderImage,
                    style: {
                        textAlign: 'center'
                    }
                });
            } else {    
                columns.push(
                {
                    Header: <b>{this.Capitalize(value.toString())}</b>,
                    accessor: value,
                    Cell: this.renderStandardCell,
                    filterMethod: (filter, row) => {
                        if (row[filter.id] && filter.value) return row[filter.id].toUpperCase().includes(filter.value.toUpperCase())
                        else return false;
                    },
                    style: {
                        textAlign: 'left'
                    }
                });
            }
        }

        if (multiSelectOption === true) {
            columns.push(
                {
                    Header: <button type="button" className="btn btn-danger btn-sm mb-0 b-r-4"
                        onClick={
                            (e) => {
                                this.setState({open: true});
/*                              
                                if (window.confirm('Are you sure you wish to remove this item?'))
                                    this.handleRemoveRows()
*/                                    
                            }}>Remove</button>,
                    id: 'remove',
                    accessor: str => "remove",
                    sortable: false,
                    style: {
                        textAlign: 'center'
                    },
                    Cell: (row) => (
                        <div>
                            <span >
                                <input type="checkbox" name={`cb${row.index}`} defaultChecked={this.state.myData[row.index]['checked']}
                                    onChange={e => this.selectRow(e, row.index)} />
                            </span>
                        </div>
                    )
                }
            )
        } else {
            columns.push(
                {
                    Header: <b>Action</b>,
                    id: 'delete',
                    accessor: str => "delete",
                    Cell: (row) => (
                        <div>                            
                            {this.props.onItemDelete &&
                            <span onClick={() => {
                                this.state.onItemDelete(row.original);
                            }}>
                                <i className="fa fa-trash" style={{ width: 35, fontSize: 20, padding: 11, color: '#e4566e' }}></i>
                            </span>
                            }                            
                            {this.props.onItemEdit &&
                            <span onClick={() => {
                                this.state.onItemEdit(row.original);
                            }}>
                                <i className="fa fa-pencil" style={{ width: 35, fontSize: 20, padding: 11,color:'rgb(40, 167, 69)' }}></i>
                            </span>
                            }
                            {this.props.onItemDashboard &&
                            <span onClick={() => {
                                this.state.onItemDashboard(row.original);
                            }}>
                                <i className="fa fa-line-chart" style={{ width: 35, fontSize: 20, padding: 11,color:'rgb(40, 167, 69)' }}></i>
                            </span>
                            }
                            {this.props.onItemDuplicate &&
                                <span onClick={() => {
                                    this.state.onItemDuplicate(row.original);
                                }}>
                                    <i className="fa fa-copy" style={{ width: 35, fontSize: 20, padding: 11, color: 'rgb(40, 167, 69)' }}></i>
                                </span>
                            }
                            {this.props.showCopy?
                            <span onClick={() => {
                                this.onCopyId(this.props.showCopy === '_id' ? row.original._id : row.original[this.props.showCopy]);

                            }}>
                                <i className="fa fa-copy" style={{ width: 35, fontSize: 20, padding: 11,color:'rgb(40, 109, 167)' }}></i>
                            </span>
                            :''
                            }
                            
                            {this.props.onItemAction?
                            <span onClick={() => this.props.onItemAction(row.original)}>
                                <i className={row.original.status === 'accepted'?"fa fa-thumbs-down":"fa fa-thumbs-up"} style={{ width: 35, fontSize: 20, padding: 11,color:'rgb(40, 109, 167)' }}></i>
                            </span>
                            :''
                            }
                        </div>
                ),
                style: {
                    textAlign: 'center'
                },
                sortable: false
            }
        )
        }
        if (Array.isArray(myData)) {
            return (
                <Fragment>
                    <ReactTable
                        filterable
                        data={myData}
                        pageSize={(myData.length > pageSize) ? pageSize : myData.length}
                        showPagination={pagination && (myData.length > pageSize)}                    
                        defaultPageSize={pageSize}
                        columns={columns}
                        className={myClass}
                        getTdProps={this.getTdProps}
                                                      
                    />
                    <ToastContainer />
                    <ModalWindow title="Confirm Deletion ..." open={this.state.open} onCancel={this.onCancel}
                        content="Are you sure you want to remove these items?"
                        commands={[
                            {title: "Yes", handler: this.handleRemoveRows}
                        ]}
                    />
                </Fragment>
            )
        } else {
            return null;
        }
    }
}

export default Datatable
